import type { FunctionComponent } from "react";
import { HeroUIProvider, ToastProvider } from "@heroui/react";
import { AuthProvider } from "@src/presentation/contexts/AuthContext";
import { SidebarProvider } from "@src/presentation/contexts/SidebarContext";
import { ChatProvider } from "@src/presentation/contexts/ChatContext";
import { MobileViewProvider } from "@src/presentation/contexts/MobileViewContext";
import { ViewedPascosProvider } from "@src/presentation/contexts/ViewedPascosContext";
import { InsufficientCreditsProvider } from "@src/presentation/contexts/InsufficientCreditsContext";
import { WhatsAppLinkProvider } from "@src/presentation/contexts/WhatsAppLinkContext";
import { AnalyticsProvider } from "@src/presentation/components/AnalyticsProvider";
import { ThemeProvider } from "next-themes";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "@src/presentation/hooks/queryClient";


interface ProvidersProps {
    children: React.ReactNode;
}

const Providers: FunctionComponent<ProvidersProps> = ({ children }) => {
    return (
        <QueryClientProvider client={queryClient}>
            <HeroUIProvider>
                <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false}>
                    <AuthProvider>
                        <WhatsAppLinkProvider>
                            <AnalyticsProvider>
                                <ChatProvider>
                                    <MobileViewProvider>
                                        <SidebarProvider>
                                            <ViewedPascosProvider>
                                                <InsufficientCreditsProvider>
                                                    <ToastProvider placement="bottom-right" />
                                                    {children}
                                                </InsufficientCreditsProvider>
                                            </ViewedPascosProvider>
                                        </SidebarProvider>
                                    </MobileViewProvider>
                                </ChatProvider>
                            </AnalyticsProvider>
                        </WhatsAppLinkProvider>
                    </AuthProvider>
                </ThemeProvider>
            </HeroUIProvider>
        </QueryClientProvider>
    );
}

export default Providers;
